/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/pause': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" _fill="#fff" d="M0 0h4v12H0zm8 0h4v12H8z"/>'
  }
})
